import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { startCase } from 'lodash'
import { ROUTE_GAME_NAME_ID, ROUTE_PATHS } from 'utils/constants/index'

const useGameStateHook = () => {
  /* ======================================= inbuilt Hooks ======================================= */

  const history = useHistory()

  /* =======================================  use selector Hooks ======================================= */

  const { systemGameData } = useSelector((state) => state.gameSetting)

  /* =======================================  useEffect Hooks ======================================= */

  let isGameActive

  useEffect(() => {
    if (systemGameData) {
      const currentGameSettings = systemGameData?.find(ele => +ele.gameId === ROUTE_GAME_NAME_ID[window.location.pathname])

      if (currentGameSettings) {
        const state = {
          gameName: startCase(currentGameSettings.game.name)
        }
        isGameActive = !currentGameSettings?.isActive
        if (isGameActive) {
          history.push(ROUTE_PATHS.inActiveGame, state)
        }
      }
    }
  }, [systemGameData])

  /* ======================================= Return data ======================================= */

  return {
    isGameActive
  }
}

export default useGameStateHook
